import { useState } from "react";
import { useIntl } from "react-intl";
import { LabelKeyValueItem } from "@/model";

import DropdownGroup, { DropdownButton, DropdownItem, DropdownItems } from "./Dropdown";
import SearchBar from "./Searchbar";


interface TypeSearchbarProps {
    width: number;
    searchTypes: LabelKeyValueItem[];
    placeholder?: string;
    onSearch: (keyword: string, option: LabelKeyValueItem) => void;
}

const TypeSearchbar: React.FC<TypeSearchbarProps> = (props) => {
    const { width, searchTypes, placeholder, onSearch } = props;

    const intl = useIntl();

    const [selectedOption, setSelectedOption] = useState<LabelKeyValueItem>(searchTypes[0]);

    const dropdownWidth = intl.locale === "en" ? 150 : 120;

    return (
        <div className="flex items-center" style={{ width: width }}>
            <DropdownGroup width={dropdownWidth}>
                {({ open, close }) => (<>
                    <DropdownButton open={open}
                                    close={close}
                                    variant="secondary"
                                    className="rounded-r-none h-full py-2.5"
                    >
                        {intl.formatMessage({ id: selectedOption.labelKey })}
                    </DropdownButton>
                    <DropdownItems variant="secondary"
                                   className="rounded-tr-none"
                    >
                        {searchTypes.map(option => (
                            <DropdownItem key={option.value}
                                          onClick={() => setSelectedOption(option)}
                            >
                                {intl.formatMessage({ id: option.labelKey })}
                            </DropdownItem>
                        ))}
                    </DropdownItems>
                </>)}
            </DropdownGroup>
            <SearchBar lg className="-ml-px rounded-l-none"
                       placeholder={placeholder ?? intl.formatMessage({ id: "i00070" })}
                       onSearch={keyword => onSearch(keyword, selectedOption)}
            />
        </div>
    );
};

export default TypeSearchbar;
